import Chips from 'components/common/Chips';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
const useStyles = makeStyles((theme) => ({
    wrapper: {
        paddingTop: 10
    },
    formControl: {
        width: '100%',
    },
    Select: {
        '&:after': {
            borderBottom: 'none'
        }
    },
    header: {
        color: '#28282E',
        fontFamily: 'Hind',
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '20px',
        paddingBottom: '5px',
    },
}));

const PI_LABEL = 'P.I.';
const STAFF_LABEL = 'Staff';

export default function CompletedSignatures({ completeSignatures }) {
    const classes = useStyles();
    function createChipLabel() {
        return completeSignatures.map(data => {
            const { displayName, id } = data.signature.user;
            const signatureDate = moment(data.signature.createdAt).format('MMM D, YYYY');
            const label = data.signatureType === 'PI_START' ? PI_LABEL : STAFF_LABEL;
            return {
                label: `${displayName} — ${label}`,
                finalLabel: `Signed ${signatureDate}`,
                value: id
            };
        });
    }
    return (
        <div className={classes.wrapper}>
            <p className={classes.header}>Completed Signatures</p>
            <Chips data={createChipLabel()} isDeletable={false} />
        </div>
    );
}